import React from 'react';
import TabButton from '../TabButton';
import styles from './index.module.scss';

export const TABS = {
  ALL: 'all',
  TESTS: 'tests',
  PRESCRIPTIONS: 'prescriptions',
  TREATMENTS: 'treatments',
};

interface Tab {
  id: string;
}

interface DashboardTabsProps {
  activeTab: string;
  setActiveTab: (tab: string) => void;
  isTestsTabVisible: boolean;
  isPrescriptionsTabVisible: boolean;
  isTreatmentsTabVisible: boolean;
}

const DashboardTabs: React.FC<DashboardTabsProps> = ({
  activeTab,
  setActiveTab,
  isTestsTabVisible,
  isPrescriptionsTabVisible,
  isTreatmentsTabVisible,
}) => {
  const getTabsData = (
    isTestsTabVisible: boolean,
    isPrescriptionsTabVisible: boolean,
    isTreatmentsTabVisible: boolean,
  ) => {
    let tabs = [] as Tab[];

    if (isTestsTabVisible) {
      tabs.push({ id: TABS.TESTS });
    }

    if (isPrescriptionsTabVisible) {
      tabs.push({ id: TABS.PRESCRIPTIONS });
    }

    if (isTreatmentsTabVisible) {
      tabs.push({ id: TABS.TREATMENTS });
    }

    if (tabs.length > 1) {
      tabs.unshift({ id: TABS.ALL });
    }

    return tabs;
  };

  const tabs = getTabsData(
    isTestsTabVisible,
    isPrescriptionsTabVisible,
    isTreatmentsTabVisible,
  );
  return (
    <div className={styles.wrapper}>
      {tabs.map((tab) => {
        return (
          <TabButton
            key={tab.id}
            tab={tab.id}
            activeTab={activeTab}
            setActiveTab={setActiveTab}
          />
        );
      })}
    </div>
  );
};

export default DashboardTabs;
